import React from 'react';
import { LoadingBox } from './LoadingBox';
import style from './AtButtonInsertForWebinarList.module.scss';

interface AtButtonInsertForWebinarListProp {
  label: string;
  iconStyle: string;
  onClickFunction?: () => void;
  loading?: boolean;
}

export const AtButtonInsertForWebinarList = ({
  label,
  iconStyle,
  onClickFunction,
  loading,
}: AtButtonInsertForWebinarListProp) => {

  const doOnClickFunction = () => {

    if (loading) return;
    if (onClickFunction) {

      onClickFunction();

    }

  };

  return (
    <div className={`${style.atButtonSmall}`} onClick={doOnClickFunction}>
      <p className={`${style.label}`}>{label}</p>
      <div className={`${style.atButtonSmallDivide}`} />
      <i className={`${style.icon} ${iconStyle}`} />
      {loading && <LoadingBox />}
    </div>
  );

};
